import { Record } from '@gonfalon/immutable-shim/immutableShim';

type BigSegmentTargetProps = {
  included: boolean;
  excluded: boolean;
};

export class BigSegmentTarget extends Record<BigSegmentTargetProps>({
  included: false,
  excluded: false,
}) {}

export function createBigSegmentTarget(props = {}) {
  return props instanceof BigSegmentTarget ? props : new BigSegmentTarget(props);
}
